function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { getSpacingTop } from "../Box/spacing";
import { getSystemFontFamilyMap } from "./fontFamily";

var fontConfigToFontPositionMap = function fontConfigToFontPositionMap(config) {
  var baselineFromTop = config.ascender;
  return {
    baseline: baselineFromTop,
    ascender: baselineFromTop - config.ascender,
    capHeight: baselineFromTop - config.capHeight,
    capCenter: baselineFromTop - config.capHeight / 2,
    xHeight: baselineFromTop - config.xHeight,
    xCenter: baselineFromTop - config.xHeight / 2,
    descender: baselineFromTop - config.descender
  };
};

var FontMetrics = /*#__PURE__*/function () {
  function FontMetrics(config) {
    _classCallCheck(this, FontMetrics);

    this.config = void 0;
    this.position = void 0;
    this.config = config;
    this.position = fontConfigToFontPositionMap(config);
  }

  _createClass(FontMetrics, [{
    key: "positionFor",
    value: function positionFor(position, _ref) {
      var size = _ref.size,
          lineHeight = _ref.lineHeight,
          padding = _ref.padding;
      var _this$config = this.config,
          unitsPerEm = _this$config.unitsPerEm,
          ascender = _this$config.ascender,
          descender = _this$config.descender;
      var unitsPerLine = ascender - descender;
      var emsPerLine = unitsPerLine / unitsPerEm;
      var contentArea = size * emsPerLine;
      var offset = (lineHeight - contentArea) / 2;
      return getSpacingTop(padding) + offset + size * this.position[position] / unitsPerEm;
    }
  }, {
    key: "configFor",
    value: function configFor(configKey, size) {
      return this.config[configKey] * size / this.config.unitsPerEm;
    }
  }]);

  return FontMetrics;
}();

export default FontMetrics;
var metricsFallback = new FontMetrics({
  unitsPerEm: 2048,
  ascender: 1920,
  descender: -512,
  lineGap: 0,
  xHeight: 1024,
  capHeight: 1440
});
var metricsSanFranciscoText = new FontMetrics({
  unitsPerEm: 2048,
  ascender: 1980,
  descender: -432,
  lineGap: 0,
  xHeight: 1078,
  capHeight: 1443
});
var fontFamilyMetrics = {
  '-apple-system': metricsSanFranciscoText,
  BlinkMacSystemFont: metricsSanFranciscoText,
  Consolas: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1521,
    descender: -527,
    lineGap: 350,
    xHeight: 1004,
    capHeight: 1307
  }),
  'Helvetica Neue': new FontMetrics({
    unitsPerEm: 1000,
    ascender: 952,
    descender: -213,
    lineGap: 28,
    xHeight: 517,
    capHeight: 714
  }),
  Menlo: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1556,
    descender: -492,
    lineGap: 410,
    xHeight: 1120,
    capHeight: 1493
  }),
  Roboto: new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1536,
    descender: -512,
    lineGap: 102,
    xHeight: 1082,
    capHeight: 1456
  }),
  'Segoe UI': new FontMetrics({
    unitsPerEm: 2048,
    ascender: 1491,
    descender: -431,
    lineGap: 269,
    xHeight: 1024,
    capHeight: 1434
  }),
  Ubuntu: new FontMetrics({
    unitsPerEm: 1000,
    ascender: 772,
    descender: -185,
    lineGap: 28,
    xHeight: 520,
    capHeight: 693
  })
};
export var getFontMetrics = function getFontMetrics(typeface) {
  var fontFamilyMap = getSystemFontFamilyMap();
  var fontFamily = fontFamilyMap[typeface];
  return fontFamilyMetrics[fontFamily] || metricsFallback;
};